module.exports = __webpack_public_path__ + "img/deco-06.5bdf85e7.png";